import { render, staticRenderFns } from "./branchFleet.vue?vue&type=template&id=ff8a30d2&"
import script from "./branchFleet.vue?vue&type=script&lang=js&"
export * from "./branchFleet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff8a30d2')) {
      api.createRecord('ff8a30d2', component.options)
    } else {
      api.reload('ff8a30d2', component.options)
    }
    module.hot.accept("./branchFleet.vue?vue&type=template&id=ff8a30d2&", function () {
      api.rerender('ff8a30d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/branchFleet.vue"
export default component.exports